import React, { useState } from 'react';

export const Gallery: React.FC<{ images: string[] }> = ({ images }) => {
  const [active, setActive] = useState(0);
  const main = images[active] ?? images[0];
  return (
    <div>
      <div className="flex items-center justify-center overflow-hidden rounded-xl bg-gray-100">
        <img
          src={main}
          alt="Listing"
          className="max-h-[440px] w-full object-contain"
          onError={(ev) => {
            (ev.currentTarget as HTMLImageElement).style.opacity = '0.3';
          }}
        />
      </div>
      {images.length > 1 && (
        <div className="mt-3 flex gap-2 overflow-x-auto pb-1">
          {images.map((src, i) => (
            <button
              key={`${src}-${i}`}
              onClick={() => setActive(i)}
              className={`h-16 w-16 shrink-0 overflow-hidden rounded-lg border-2 transition-colors ${
                i === active ? 'border-indigo-500' : 'border-transparent hover:border-gray-300'
              }`}
            >
              <img src={src} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
